/*!
 * devextreme-angular
 * Version: 19.1.3
 * Build date: Tue May 14 2019
 *
 * Copyright (c) 2012 - 2019 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/* tslint:disable:max-line-length */


import {
    Component,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';




import DevExpress from 'devextreme/bundles/dx.all';

import { NestedOptionHost } from '../../core/nested-option';
import { NestedOption } from '../../core/nested-option';


@Component({
    selector: 'dxo-strip-style',
    template: '',
    styles: [''],
    providers: [NestedOptionHost]
})
export class DxoStripStyleComponent extends NestedOption {
    @Input()
    get label(): { font?: DevExpress.viz.Font, horizontalAlignment?: string, verticalAlignment?: string } | { font?: DevExpress.viz.Font } {
        return this._getOption('label');
    }
    set label(value: { font?: DevExpress.viz.Font, horizontalAlignment?: string, verticalAlignment?: string } | { font?: DevExpress.viz.Font }) {
        this._setOption('label', value);
    }

    @Input()
    get paddingLeftRight(): number {
        return this._getOption('paddingLeftRight');
    }
    set paddingLeftRight(value: number) {
        this._setOption('paddingLeftRight', value);
    }

    @Input()
    get paddingTopBottom(): number {
        return this._getOption('paddingTopBottom');
    }
    set paddingTopBottom(value: number) {
        this._setOption('paddingTopBottom', value);
    }


    protected get _optionPath() {
        return 'stripStyle';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }

}

@NgModule({
  declarations: [
    DxoStripStyleComponent
  ],
  exports: [
    DxoStripStyleComponent
  ],
})
export class DxoStripStyleModule { }
